import { HttpClient } from "@angular/common/http";
import { inject, Injectable } from "@angular/core";
import {
  NotificationMasterCreateRequestDTO,
  NotificationMasterDTO,
  NotificationMasterList,
  NotificationMasterReadAllPaginated,
  PushNotificationConfigDTO,
  PushNotificationConfigList,
  PushNotificationDeleteByUserIdRequestDTO,
  PushNotificationReadByIdRequestDTO,
  PushNotificationSendMessageRequestDTO,
  PushNotificationSendMessageToTopicRequestDTO
} from "./notificationMaster.interface";
import { Observable } from "rxjs";
import {
  NotificationMaster_Create,
  NotificationMaster_ExternalCreate,
  NotificationMaster_ReadAll,
  NotificationMaster_ReadAllPaginated
} from "src/app/GlobalVariable";

import {
  PushNotificationConfig_DeleteByUserId,
  PushNotificationConfig_ReadById,
  PushNotificationConfig_Register,
  PushNotificationConfig_SendMessage,
  PushNotificationConfig_SendMessageToTopic,
} from "src/app/GlobalVariable";


@Injectable({
    providedIn: 'root',
})


export class NotificationMasterService {

    private http = inject(HttpClient);

    NotificationMaster_Create(data: NotificationMasterCreateRequestDTO): Observable<NotificationMasterDTO> {
        return this.http.post<NotificationMasterDTO>(NotificationMaster_Create, data);
    };

    NotificationMaster_ExternalCreate(data: NotificationMasterCreateRequestDTO): Observable<NotificationMasterDTO> {
        return this.http.post<NotificationMasterDTO>(NotificationMaster_ExternalCreate, data);
    };

    NotificationMaster_ReadAll(): Observable<NotificationMasterList> {
        return this.http.get<NotificationMasterList>(NotificationMaster_ReadAll)
    };

    NotificationMaster_ReadAllPaginated(data: NotificationMasterReadAllPaginated): Observable<NotificationMasterList> {
        return this.http.post<NotificationMasterList>(NotificationMaster_ReadAllPaginated, data);
    };

    PushNotificationConfig_Register(data: any): Observable<PushNotificationConfigDTO> {
    return this.http.post<PushNotificationConfigDTO>(PushNotificationConfig_Register,data);
  }

  PushNotificationConfig_ReadById(data: PushNotificationReadByIdRequestDTO): Observable<PushNotificationConfigDTO> {
    return this.http.post<PushNotificationConfigDTO>(PushNotificationConfig_ReadById,data);
  }

  PushNotificationConfig_SendMessage(data: PushNotificationSendMessageRequestDTO): Observable<PushNotificationConfigList> {
    return this.http.post<PushNotificationConfigList>(PushNotificationConfig_SendMessage,data);
  }

  PushNotificationConfig_DeleteByUserId(data: PushNotificationDeleteByUserIdRequestDTO): Observable<PushNotificationConfigDTO> {
    return this.http.post<PushNotificationConfigDTO>(PushNotificationConfig_DeleteByUserId,data);
  }

  PushNotificationConfig_SendMessageToTopic(data: PushNotificationSendMessageToTopicRequestDTO): Observable<PushNotificationConfigList> {
    return this.http.post<PushNotificationConfigList>(PushNotificationConfig_SendMessageToTopic,data);
  }


}
